import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";
import { endpointsURL } from "src/app/constants/endpointsURL";
import {
  CampoValorLI,
  DtoToRemove,
  FieldAvailable,
} from "src/app/maintenance-royal-decree/models/availablefields.model";
import { MoveUpDownFieldsLinked } from "src/app/maintenance-royal-decree/models/specificFields.model";

@Injectable({
  providedIn: "root",
})
export class RoyalDecreeService {
  public env = environment.env;
  public maintenanceAvailableFieldsRoyalDecree =
    endpointsURL.maintenanceAvailableFieldsRoyalDecree;

  public maintenanceSpecificFieldsRoyalDecree =
    endpointsURL.maintenanceSpecificFieldsRoyalDecree;

  public camposValoresLI = endpointsURL.camposValoresLI;

  constructor(private httpClient: HttpClient) {}

  public listFieldsAvailable(filters: string): Observable<any[]> {
    return this.httpClient.get<any[]>(
      `${this.env}${this.maintenanceAvailableFieldsRoyalDecree}list${filters}`
    );
  }

  public getOneFieldAvailable(
    idFieldAvailable: string
  ): Observable<FieldAvailable> {
    return this.httpClient.get<FieldAvailable>(
      `${this.env}${this.maintenanceAvailableFieldsRoyalDecree}edit/${idFieldAvailable}`
    );
  }

  public createFieldAvailable(
    fieldAvailable: any,
    file: Blob
  ): Observable<any> {
    const fd = new FormData();
    if (file == null) {
      fd.append("file", new Blob([], { type: "text/html" }));
    } else {
      fd.append("file", file);
    }
    fd.append("campodisponibleDto", JSON.stringify(fieldAvailable));
    return this.httpClient.post<any>(
      `${this.env}${this.maintenanceAvailableFieldsRoyalDecree}edit`,
      fd
    );
  }

  public updateFieldAvailable(
    fieldAvailable: any,
    file: Blob
  ): Observable<any> {
    const fd = new FormData();
    if (file == null) {
      fd.append("file", new Blob([], { type: "text/html" }));
    } else {
      fd.append("file", file);
    }
    fd.append("campodisponibleDto", JSON.stringify(fieldAvailable));
    return this.httpClient.put<any>(
      `${this.env}${this.maintenanceAvailableFieldsRoyalDecree}edit/${fieldAvailable.cdId}`,
      fd
    );
  }

  public removeFieldsAvailable(ids: string[]): Observable<any> {
    let params = new HttpParams();

    ids.forEach((e) => {
      params = params.append("ids", e);
    });
    return this.httpClient.delete<any>(
      `${this.env}${this.maintenanceAvailableFieldsRoyalDecree}edit/{id}`,
      {
        params: params,
      }
    );
  }

  public getListAvailableFields(): Observable<any> {
    return this.httpClient.get<any>(
      `${this.env}${this.maintenanceSpecificFieldsRoyalDecree}/camposdisponibles/list`
    );
  }

  public createFieldToCertificate(
    certificate: any,
    idCertificado: string
  ): Observable<any> {
    return this.httpClient.post<any>(
      `${this.env}${this.maintenanceSpecificFieldsRoyalDecree}/certificados/edit/${idCertificado}`,
      certificate
    );
  }

  public listAllOtherCertificates(): Observable<any> {
    return this.httpClient.get<any>(
      `${this.env}${this.maintenanceSpecificFieldsRoyalDecree}/certificados/listAll`
    );
  }

  public listOtherCertificates(): Observable<any> {
    return this.httpClient.get<any>(
      `${this.env}${this.maintenanceSpecificFieldsRoyalDecree}/certificados/list`
    );
  }

  public listFieldsLinkedToCertificate(
    filter: string,
    idCertificado: string
  ): Observable<any> {
    return this.httpClient.get<any>(
      `${this.env}${this.maintenanceSpecificFieldsRoyalDecree}/certificados/list/${idCertificado}?${filter}`
    );
  }

  public listBooleanFieldsOfCertificate(
    idCertificado: string
  ): Observable<any> {
    return this.httpClient.get<any>(
      `${this.env}${this.maintenanceSpecificFieldsRoyalDecree}/certificados/listbooleanos/${idCertificado}`
    );
  }

  public removeField(idsCertificado: string[]): Observable<any> {
    let params = new HttpParams();

    idsCertificado.forEach((e) => {
      params = params.append("uniqueids", e);
    });
    return this.httpClient.delete<any>(
      `${this.env}${this.maintenanceSpecificFieldsRoyalDecree}/edit`,
      {
        params: params,
      }
    );
  }

  public linkBooleanToOtherField(
    idCampoBooleano: string,
    uniqueid: string,
    valor: string
  ): Observable<any> {
    return this.httpClient.post<any>(
      `${this.env}${this.maintenanceSpecificFieldsRoyalDecree}/edit/link?idCampoBooleano=${idCampoBooleano}&uniqueid=${uniqueid}&valor=${valor}`,
      {}
    );
  }

  public addFieldForReform(
    fieldsCertificate: any,
    idReform: string
  ): Observable<any> {
    return this.httpClient.post<any>(
      `${this.env}${this.maintenanceSpecificFieldsRoyalDecree}/reformas/edit/${idReform}`,
      fieldsCertificate
    );
  }

  public listImportantReform(): Observable<any> {
    return this.httpClient.get<any>(
      `${this.env}${this.maintenanceSpecificFieldsRoyalDecree}/reformas/list`
    );
  }

  public listFieldsLinkedToReform(
    filter: string,
    idReform: string
  ): Observable<any> {
    return this.httpClient.get(
      `${this.env}${this.maintenanceSpecificFieldsRoyalDecree}/reformas/list/${idReform}${filter}`
    );
  }

  public listFieldsBooleansLinkedToReform(idReform: string): Observable<any> {
    return this.httpClient.get(
      `${this.env}${this.maintenanceSpecificFieldsRoyalDecree}/reformas/listbooleanos/${idReform}`
    );
  }

  public addOtherCertificate(certificate: any): Observable<any> {
    return this.httpClient.post(
      `${this.env}${this.maintenanceSpecificFieldsRoyalDecree}/certificados/edit`,
      certificate
    );
  }

  public updateOtherCertificate(certificate: any): Observable<any> {
    return this.httpClient.put(
      `${this.env}${this.maintenanceSpecificFieldsRoyalDecree}/certificados/edit/${certificate.tcId}`,
      certificate
    );
  }
  public removeOtherCertificate(certificateId: string): Observable<any> {
    return this.httpClient.delete(
      `${this.env}${this.maintenanceSpecificFieldsRoyalDecree}/certificados/edit/${certificateId}`
    );
  }

  public addReform(reform: any): Observable<any> {
    return this.httpClient.post(
      `${this.env}${this.maintenanceSpecificFieldsRoyalDecree}/reformas/edit`,
      reform
    );
  }

  public updateReform(reform: any): Observable<any> {
    return this.httpClient.put(
      `${this.env}${this.maintenanceSpecificFieldsRoyalDecree}/reformas/edit/${reform.reId}`,
      reform
    );
  }

  public removeReform(reformId: string): Observable<any> {
    return this.httpClient.delete(
      `${this.env}${this.maintenanceSpecificFieldsRoyalDecree}/reformas/edit/${reformId}`
    );
  }

  public generateReformCod(reformId: string): Observable<any> {
    return this.httpClient.get(
      `${this.env}${this.maintenanceSpecificFieldsRoyalDecree}/reformas/generaCodigoReforma/${reformId}`
    );
  }

  public createCampoValorLI(formValue: CampoValorLI): Observable<any> {
    return this.httpClient.post(
      `${this.env}${this.camposValoresLI}create`,
      formValue
    );
  }

  public removeCampoValorLI(fields: DtoToRemove): Observable<any> {
    return this.httpClient.post(
      `${this.env}${this.camposValoresLI}remove`,
      fields
    );
  }

  public moveUpOrDownLinkedField(
    dtoToMove: MoveUpDownFieldsLinked
  ): Observable<any> {
    return this.httpClient.post(
      `${this.env}${this.maintenanceSpecificFieldsRoyalDecree}/change/position`,
      dtoToMove
    );
  }
}
